const formatResultDate = (dateString) => {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${month}/${day}, ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
};

const OneCardMeterResult = ({ resultData = [] }) => {

    //console.log("🔥🔥🔥 ONE CARD COMPONENT RENDERED 🔥🔥🔥");

    //console.log("OneCardMeterResult resultData:", resultData);
    //console.log("Is Array:", Array.isArray(resultData));

    return (

        <div className="left-content">
            {resultData.map((row, index) => {

                {/*console.log("ROW:", row);
                console.log("AC1:", row.ac1);
                console.log("AC2:", row.ac2);
                console.log("RESULT:", row.result);*/}

                const players = [
                    {
                        label: row.cat_rnr1 || "Player A",
                        card: row.ac1,
                        winner:
                            row.result === "1" ||
                            row.result === 1
                    },
                    {
                        label: row.cat_rnr2 || "Player B",
                        card: row.ac2,
                        winner:
                            row.result === "2" ||
                            row.result === 2
                    }
                ];

                return (

                    <div
                        key={index}
                        className="card"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            padding: "10px",
                            marginBottom: "8px",
                            background:
                                "linear-gradient(rgb(15,15,15), rgb(251,251,251))"
                        }}
                    >

                        <div
                            style={{
                                fontWeight: "bold",
                                fontSize: "16px",
                                marginBottom: "12px", color: "#fff", marginTop: "8px", marginLeft: "10px"
                            }}
                        >
                            {formatResultDate(row.evt_od)} - <b>ID=</b> {row._id}
                        </div>

                        <div
                            class="only-mob"
                            style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                                gap: "15px",
                                flexWrap: "wrap"
                            }}
                        >

                            {players.map((player, i) => (

                                <div
                                    key={i}
                                    style={{
                                        width: "290px",
                                        borderRadius: "10px",
                                        overflow: "hidden",
                                        background: player.winner
                                            ? "#1b5e20"
                                            : "#555"
                                    }}
                                >

                                    <div
                                        style={{
                                            textAlign: "center",
                                            fontWeight: "bold",
                                            color: "#fff"
                                        }}
                                    >
                                        {player.label}
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            minHeight: "65px"
                                        }}
                                    >

                                        {player.card ? (

                                            <img
                                                src={`/assets/images/cards/${player.card}.svg`}
                                                alt=""
                                                draggable={false}
                                                style={{
                                                    width: "45px"
                                                }}
                                            />

                                        ) : (

                                            <div
                                                style={{
                                                    width: "45px",
                                                    height: "62px"
                                                }}
                                            />

                                        )}

                                    </div>

                                    <div
                                        style={{
                                            background: player.winner
                                                ? "#cf8d2e"
                                                : "#cf3f3f",
                                            color: "#000",
                                            textAlign: "center",
                                            fontWeight: "bold",
                                            borderRadius: "10px"
                                        }}
                                    >
                                        {player.winner
                                            ? "WINNER"
                                            : "LOSER"}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
            <style>
                {`
                @media(max-width:576px){
                    .only-mob {
                        display: flex !important;
                        justify-content: space-between !important;
                        align-items: stretch !important;
                        gap: 5px !important;
                        width: 100% !important;
                    }
                    .only-mob > div {
                        flex: 1 1 0 !important;
                        min-width: 0 !important;
                        width: auto !important;
                    }
                }
                `}
            </style>
        </div>
    );
};

export default OneCardMeterResult;


